/** @ngInject */
export default function riskReportController($scope, $uibModalInstance, $http, userConfig, userScenarioDefinitions) {

    $http.get("/tradefloor/api/rm/report/assets", {}).then(function (response) {
        var data = response.data;
        $scope.sectorAssets = data.sectorAssets;
        $scope.securityAssets = data.securityAssets;
    });

    $scope.updateScenario = function (scenario, assetName, assetType) {
        scenario.assetName = assetName;
        scenario.assetType = assetType;
    };

    $scope.modalInstance = $uibModalInstance;
    $scope.scenarios = userScenarioDefinitions.data.scenarioDefinitions;
    $scope.stelReport = userScenarioDefinitions.data.stelReport;
    $scope.riskReport = userScenarioDefinitions.data.riskReport;

    $scope.scenarios.forEach(function (s) {
        s.collapsed = true;
        s.priceText = s.price;
        s.volText = s.vol;
        s.price = s.price / 100;
        s.vol = s.vol / 100;
    });

    $scope.addScenario = function () {
        var newScenario = {
            id: null,
            price: 0,
            priceText: 0,
            vol: 0,
            volText: 0,
            collapsed: true,
            assetName: "Market",
            assetType: "MARKET"
        };
        $scope.scenarios.push(newScenario);
        $scope.collapseScenario(newScenario);
    };

    $scope.removeScenario = function (scenario) {
        $scope.scenarios.splice($scope.scenarios.indexOf(scenario), 1);
    };

    $scope.collapseScenario = function (scenario) {
        scenario.collapsed = !scenario.collapsed;
        if (!scenario.collapsed) {
            $scope.scenarios.forEach(function (s) {
                if (s !== scenario) {
                    s.collapsed = true;
                }
            });
        }
    };

    $scope.save = function () {
        var data = $scope.scenarios.filter(function (s) {
            return s.volText != 0 || s.priceText != 0;
        })
                         .map(function (s) {
                             return {
                                 id: s.id,
                                 price: s.priceText,
                                 vol: s.volText,
                                 assetName: s.assetName,
                                 assetType: s.assetType
                             }
                         });
        var scenarioResponse = {
            scenarioDefinitions: data,
            stelReport: $scope.stelReport,
            riskReport: $scope.riskReport

        };
        $http.put("/tradefloor/api/rm/report/scenarios", scenarioResponse).then(function () {
            $uibModalInstance.close();
        });
    }
};